import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

export default function FinalCTA() {
  const [animated, setAnimated] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setAnimated(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const handleJoinWaitlist = () => {
    navigate('/');
    setTimeout(() => {
      const el = document.getElementById('final-cta');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  const handleClaimSpot = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false);
      navigate('/');
      setTimeout(() => {
        const el = document.getElementById('final-cta');
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }, 1000);
  };

  return (
    <section ref={sectionRef} className="relative py-16 sm:py-20 lg:py-32 bg-white">
      <div className="max-w-[1000px] mx-auto px-4 sm:px-6 lg:px-8">
        <div
          className={`text-center space-y-6 sm:space-y-8 lg:space-y-10 transition-all duration-700 ${
            animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
          }`}
        >
          <h2 className="font-harvey-serif text-[#09090b] text-[32px] sm:text-[42px] lg:text-[52px] font-normal tracking-tight leading-tight">
            This Is What You've Been Waiting For
          </h2>

          <p className="font-harvey-sans text-[#52525b] text-base sm:text-lg lg:text-xl font-light tracking-wide leading-relaxed max-w-[700px] mx-auto">
            AI that drafts your pleadings. From your phone. In seconds. Without compromising privilege
          </p>

          <p className="font-harvey-sans text-[#09090b] text-base sm:text-lg lg:text-xl font-medium tracking-wide">
            Founder spots are limited. Pre-Launch pricing ends at launch
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 pt-4">
            <button
              onClick={handleClaimSpot}
              disabled={isSubmitting}
              className="bg-[#d4af37] text-black text-[15px] sm:text-[18px] font-bold px-6 sm:px-8 py-4 rounded-xl sm:rounded-l-none sm:rounded-r-xl hover:shadow-[0_0_30px_rgba(212,175,55,0.6)] transition-all duration-200 animate-pulse-glow whitespace-nowrap cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isSubmitting ? 'Claiming...' : 'Claim Founders Spot'}
            </button>
            <button
              onClick={handleJoinWaitlist}
              className="font-harvey-sans w-full sm:w-auto px-6 sm:px-8 py-4 bg-[#8B4513] text-white text-sm sm:text-base lg:text-lg font-medium tracking-wide rounded-full hover:shadow-[0_0_40px_rgba(139,69,19,0.4)] transition-all cursor-pointer whitespace-nowrap"
            >
              Join Pre-Launch — $79/mo
            </button>
          </div>

          <p className="font-harvey-sans text-[#71717a] text-xs sm:text-sm lg:text-base font-light tracking-wide flex items-center justify-center gap-2">
            <span className="text-base sm:text-lg">🔒</span>
            14-day refund guarantee. No questions asked
          </p>
        </div>
      </div>
    </section>
  );
}
